import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { TieService } from '../../_core/services/tie.service';
import { DisciplineEnum } from '../../_shared/models/csTypes/enums/discipline';
import { Tie } from '../../_shared/models/tie.model';

@Component({
  standalone: false,
    selector: 'app-add-collection-definition',
    templateUrl: './add-collection-definition.component.html',
    styleUrls: ['./add-collection-definition.component.scss'],
})
export class AddCollectionDefinitionComponent implements OnInit {

    @Input() tie: Tie;
    form: UntypedFormGroup;
    isSubmitting = false;

    constructor(
        private fb: UntypedFormBuilder,
        private modalController: ModalController,
        private tieService: TieService,
    ) { }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        if (!this.tie.discipline) this.tie.discipline = DisciplineEnum.TENNIS;

        this.form = this.fb.group({
            discipline: [this.tie.discipline],
            collectionName: [this.tie.discipline === DisciplineEnum.TENNIS ? 'Singles' : 'Doubles'],
            matchUpType: [this.tie.discipline === DisciplineEnum.TENNIS ? 'SINGLES' : 'DOUBLES'],
            matchUpCount: [1],
            matchUpFormat: [this.getMatchFormat()],
            collectionValue: [],
            exhibition: [false],
            matchUpValue: [1],
            gameValue: [0],
            pointValue: [0]
        });

        this.form
            .get('matchUpType')
            .valueChanges
            .subscribe(
                value => {
                    if (value === 'SINGLES') this.form.get('collectionName').setValue('Singles');
                    else if (value === 'DOUBLES') this.form.get('collectionName').setValue('Doubles');
                }
            );
    }

    updateCollectionMatchFormat(matchFormat) {
        this.form.get('matchUpFormat').setValue(matchFormat);
    }

    createCollection() {
        if (this.form.invalid) return;
        this.isSubmitting = true;
        this.tieService
            .addCollectionDefinition(this.tie._id, this.form.value)
            .pipe(finalize(() => this.isSubmitting = false))
            .subscribe({
                next: (res) => {
                    this.modalController.dismiss(res.data);
                }
            });
    }

    scoringChanged(ev) {
        if (ev.detail.value === 'matchUpValue') {
            this.form.get('matchUpValue').setValue(1);
            this.form.get('collectionValue').reset();
            this.form.get('gameValue').reset();
        } else if (ev.detail.value === 'collectionValue') {
            this.form.get('matchUpValue').setValue(0);
            this.form.get('gameValue').setValue(0);
            this.form.get('collectionValue').setValue(1);
            this.form.get('collectionValue').setValidators(Validators.required);
        } else if (ev.detail.value === 'gameValue') {
            this.form.get('matchUpValue').setValue(0);
            this.form.get('collectionValue').reset();
            this.form.get('gameValue').setValue(1);
        } else if (ev.detail.value === 'pointValue') { 
            this.form.get('matchUpValue').setValue(0);
            this.form.get('collectionValue').reset();
            this.form.get('gameValue').reset();
            this.form.get('pointValue').setValue(1);
        }
    }

    close() {
        this.modalController.dismiss();
    }

    getMatchFormat() {
        console.log('this.tie.discipline', this.tie.discipline);
        switch (this.tie.discipline) {
            case DisciplineEnum.TENNIS:
                return 'SET3-S:6/TB7@6';
            case DisciplineEnum.PICKLEBALL:
                return 'SET3-S:1/WB2-G:11/S';
            case DisciplineEnum.BADMINTON:
                return 'SET3-S:1/WB2:30-G:21/R';
            case DisciplineEnum.TABLE_TENNIS:
                return 'SET5-S:TB11';
            case DisciplineEnum.SQUASH:
                return 'SET3-S:TB11';
            default:
                return 'SET3-S:1/WB2-G:11/S';
        }
    }

}
